function debounce(fn, delay = 400) {
  let timeoutId = null;
  const debounced = function (...args) {
    if (timeoutId !== null) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fn.apply(this, args);
      timeoutId = null;
    }, delay);
  };
  debounced.cancel = function () {
    if (timeoutId !== null) { clearTimeout(timeoutId); timeoutId = null; }
  };
  return debounced;
}

export { debounce };
